interface IProps {
  size?: number;
}

const AparatIcon = ({ size = 20 }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12.001 1.594c-9.27-.003-13.913 11.203-7.36 17.758a10.403 10.403 0 0 0 17.76-7.355c0-5.744-4.655-10.401-10.4-10.403M6.11 6.783c.501-2.598 3.893-3.294 5.376-1.103s-.422 5.082-3.02 4.582A2.97 2.97 0 0 1 6.11 6.783m4.322 8.988c-.504 2.597-3.896 3.288-5.377 1.096s.427-5.08 3.025-4.579a2.97 2.97 0 0 1 2.352 3.483m1.26-2.405c-1.152-.223-1.462-1.727-.491-2.387c.97-.66 2.256.18 2.04 1.334a1.32 1.32 0 0 1-1.548 1.053m6.198 3.838c-.501 2.598-3.893 3.293-5.376 1.103s.421-5.082 3.02-4.583a2.97 2.97 0 0 1 2.356 3.48m-1.967-5.502c-2.598-.501-3.293-3.896-1.102-5.38s5.081.422 4.582 3.02a2.97 2.97 0 0 1-3.48 2.36M13.59 23.264l2.264.61a3.715 3.715 0 0 0 4.543-2.636l.64-2.402a11.38 11.38 0 0 1-7.448 4.428m7.643-19.665l-2.363-.629a11.38 11.38 0 0 1 4.354 7.62l.65-2.459A3.715 3.715 0 0 0 21.231 3.6M.672 13.809l-.541 2.04a3.715 3.715 0 0 0 2.636 4.543l2.107.562a11.38 11.38 0 0 1-4.203-7.145M10.357.702L8.15.126a3.715 3.715 0 0 0-4.547 2.637l-.551 2.082A11.38 11.38 0 0 1 10.358.702"
      />
    </svg>
  );
};
export default AparatIcon;
